export default __webpack_public_path__ + "bec411cce831dc8098303bc303cc7a09.png";